import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  type OnInit,
  Output,
  inject,
} from '@angular/core';

import { map, type Observable, of } from 'rxjs';
import { DialogComponent } from '@bizzdesign/ui-components';
import {
  DefaultDialogSize,
  type DialogProperties,
} from '@bizzdesign/shared/models';
import { TranslocoService } from '@jsverse/transloco';
import { SharedI18nModule } from '@bizzdesign/shared/i18n';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { SkeletonModule } from 'primeng/skeleton';
import { TooltipModule } from 'primeng/tooltip';
import { InputGroupModule } from 'primeng/inputgroup';
import { type PopulationItem } from '@bizzdesign/data-access-populations';
import { BizzdesignSdk } from '@bizzdesign/bizzdesign-sdk';
import { type Frame } from '@bizzdesign/sdk-population';

@Component({
  selector: 'bd-delete-population-modal',
  standalone: true,
  imports: [
    AsyncPipe,
    SharedI18nModule,
    SkeletonModule,
    ButtonModule,
    FormsModule,
    TooltipModule,
    InputGroupModule,
    DialogComponent,
  ],
  templateUrl: './delete-population-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeletePopulationModalComponent implements OnInit {
  private translocoService = inject(TranslocoService);
  private sdk = inject(BizzdesignSdk);

  @Input() visible: boolean = false;
  @Input({ required: true }) declare population: PopulationItem;
  @Input() loading: boolean = false;
  @Input() usedInFrames: Frame[] = [];

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() deletePopulation = new EventEmitter<PopulationItem>();

  dialogProperties$: Observable<DialogProperties> = of();

  ngOnInit(): void {
    this.dialogProperties$ = this.translocoService
      .selectTranslate(
        'deletePopulationModal.header',
        undefined,
        'featurePopulations',
      )
      .pipe(
        map((title) => ({
          defaultHeader: {
            headerTitle: title,
          },
          defaultSize: DefaultDialogSize.MEDIUM,
        })),
      );
  }

  cancel() {
    this.setVisibility(false);
  }

  delete() {
    this.deletePopulation.emit(this.population);
    this.setVisibility(false);
  }

  setVisibility(visible: boolean) {
    this.visible = visible;
    this.visibleChange.emit(this.visible);
  }
}
